module.exports = __webpack_public_path__ + "index_pc/img/xian_1.6e213c41.jpg";